import escapeRegExp from 'lodash.escaperegexp';
import type { ComboboxMultipleProperties } from '@src/components/input/ComboboxMultiple';

type UseOptionsParams<T> = Pick<
  ComboboxMultipleProperties<T>,
  'options' | 'displayValue'
> & { readonly query: string };

type MatchedOption<T> = {
  option: T;
  matchedText: string[];
};

export function splitMatch(hayStack: string, needle: string): string[] {
  const regex = new RegExp(`(${escapeRegExp(needle)})`, 'gi');
  return hayStack.split(regex);
}

export function useMatchedOptions<T>({
  options = [],
  displayValue,
  query,
}: UseOptionsParams<T>): MatchedOption<T>[] {
  return options.map((option) => ({
    option,
    matchedText: splitMatch(displayValue(option), query),
  }));
}
